<div class="wrapper">
    <span>{{data.message}} </span>
    <span class="spacer"></span>
    <button mat-button (click)="close()">{{data.action.label}}</button>
</div>
